import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class LoadMoreReports {

    constructor() {
        this.settings = {
            $reportsList: $(".js-reports-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$reportsList != null) {

            let reportsList = this.settings.$reportsList; // The container element that holds the list of reports
            let loadNr = $('#js-nr-reports-default').val(); // The number of reports to load
            let loadMoreBtn = $(".js-load-more-reports"); // The button that triggers the loading of more reports

            function reportsTypeList() {
                // Remove hidden class from all the reports
                $('.js-report-single').removeClass('hidden');

                reportsList.find('.js-report-single').each(function (index) {

                    // Hide reports that have a higher index than the number of reports to load
                    if (index >= loadNr) {
                        $(this).addClass('hidden');
                    }
                });
            }

            reportsTypeList();

            // Hide the load more button if there are no more reports to load initially
            if (reportsList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            // Load more reports when the button is clicked
            loadMoreBtn.on('click',  (e) => {

                const $this = e.currentTarget;

                let moreReports = reportsList.find('.hidden'); // The reports that are currently hidden
                let counter = 0; // Counter to keep track of the number of reports that have been shown
                moreReports.each(function () {

                    // Stop the loop when the number of reports that have been shown is equal to the number of reports to load
                    if (counter >= loadNr) {
                        return false;
                    }

                    // Increment the counter
                    counter++;

                    // Show the report
                    $(this).removeClass('hidden');
                });

                // Hide the load more button if there are no more reports to load
                if (reportsList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }

                ScrollTrigger.refresh();
            });

        }

    }
};

new LoadMoreReports();